$(document).ready(function () {
  const htmlEditor = document.getElementById("htmlEditor");

  if (htmlEditor) {
    sceditor.command.set("headers", {
      exec: function (caller) {
        var editor = this,
          $content = $("<div />");

        for (var i = 1; i <= 2; i++) {
          $(
            '<a class="sceditor-header-option" href="#">' +
              "<h" +
              i +
              ">H" +
              i +
              "</h" +
              i +
              ">" +
              "</a>"
          )
            .data("headersize", i)
            .click(function (e) {
              editor.execCommand(
                "formatblock",
                "<h" + $(this).data("headersize") + ">"
              );
              editor.closeDropDown(true);

              e.preventDefault();
            })
            .appendTo($content);
        }

        editor.createDropDown(caller, "header-picker", $content.get(0));
      },
      tooltip: "Format Headers",
    });

    sceditor.command.set("text", {
      exec: function (caller) {
        var textarea = this;

        $(".sceditor-button-text").click(function (evt) {
          textarea.clearBlockFormatting();

          evt.preventDefault();
        });
      },
    });

    sceditor.formats.bbcode
      .set("h1", {
        tags: { h1: null },
        format: "[h1]{0}[/h1]",
        html: "<h1>{0}</h1>",
        isInline: false,
      })
      .set("h2", {
        tags: { h2: null },
        format: "[h2]{0}[/h2]",
        html: "<h2>{0}</h2>",
        isInline: false,
      });

    sceditor.create(htmlEditor, {
      format: "bbcode",
      emoticonsEnabled: false,
      toolbar: "headers|text|bold|italic|strike|link",
      style: "/app/css/include/sceditorBody.css",
    });
  }
});
